export enum DraftActionTypes {
  SetDraft = 'DRAFT/SET_DRAFT',
  SetCheckDraft = 'DRAFT/SET_CHECK_DRAFT',
  SetFormDraft = 'DRAFT/SET_FORM_DRAFT',
}
